import React, { useCallback, useEffect, useRef, useState } from 'react'
import api from '../../../../middleware/api';
import { toast } from 'react-toastify';
import { PlusIcon } from '@heroicons/react/16/solid';
import { TrashIcon } from '@heroicons/react/24/outline';
import TableHeaderButton from '../../../Common/DaisyTable/TableHeaderButton/TableHeaderButton';
import SidebarDrawer from '../../../Common/SidebarDrawer/SidebarDrawer';
import CreateCustomerForm from '../Forms/CreateCustomerForm';
import DeleteMultipleCustomersModal from './DeleteMultipleCustomersModal/DeleteMultipleCustomersModal';

const CustomersHeaderActions = ({ setTableData, table }) => {
  const drawerRef = useRef(null);
  const modalRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([])
  const handleShowDrawer = useCallback(() => {
    if (drawerRef.current) {
      drawerRef.current.checked = true
    } else {
      console.warn('drawerRef is not available')
    }
  }, [drawerRef]);

  const handleShowModal = () => {
    if (modalRef.current) {
      const rows = [...table.getSelectedRowModel().rows];
      if (rows.length === 0) return toast.warning('Veuillez sélectionner un/des mélanges', { autoClose: 800 });
      setSelectedRows(rows);
      console.log(rows)
      modalRef.current.showModal()
    } else {

      setSelectedRows([])
      console.warn('modalRef is not available')
    }
  }

  const handleUpdateTable = async (selectedIds) => {
    table.options.meta?.removeBatchRows(selectedIds);
    table.resetRowSelection();
    setSelectedRows([]);

  }


  return (
    <>
      <div className="w-full max-w-screen-xl flex m-auto items-center justify-between  px-4 py-2 h-fit mb-4 border-x-0 border-t-0  border-container ">
        <TableHeaderButton className={'btn-primary'} Icon={<PlusIcon className='h-5 w-5' />} text="Nouveau client" onClick={handleShowDrawer} />
        <TableHeaderButton className={'btn-warning'} Icon={<TrashIcon className='h-5 w-5' />} text="Supprimer la sélection" onClick={handleShowModal} />
      </div>
      <SidebarDrawer ref={drawerRef} id={'createMixtureDrawer'}>
        <CreateCustomerForm setTableData={setTableData} />
      </SidebarDrawer>
      <DeleteMultipleCustomersModal ref={modalRef} users={selectedRows} updateTable={handleUpdateTable} />
    </>
  )
}

export default CustomersHeaderActions
